import React from 'react';
import './publications.css';
import { FiBookOpen } from 'react-icons/fi';

const Publications = () => {
  return (
    <section id='publications'>
      <h5>My Research Work</h5>
      <h2>Publications</h2>
      <div className="container publications__container">
        <article className="publications__details">
          <FiBookOpen className='publications__details-icon' />
          <div>
            <h4>
              <a href="https://ieeexplore.ieee.org/document/10969593" target="_blank" rel="noopener noreferrer" className="publication__link">
                An approach to detect and analyze continuous emotions in a real-time online classroom
              </a>
            </h4>
            <small className='text-light'>Mochahari, I. D., Brahma, S. R., & Maity, R. (2025). Complex System Modeling and Simulation.</small>
          </div>
        </article>
      </div>
    </section>
  );
};

export default Publications;
